module.exports = __webpack_public_path__ + "img/2-profession-application-banner.c9f3eb90.webp";